export const Status = {
	"PENDING": 1
	,
	"REJECTED": 2
	,
	"SIGNED": 3
	
}
Object.freeze(Status);
const toTypeMap = {};
Object.keys(Status).forEach(key => {
	toTypeMap[Status[key]] = key;
});
export function getStatus (value) {
	return toTypeMap[value];
}

export function getAllStatus () {
    return Object.keys(Status);
}

export const STATUS_PENDING = "PENDING";
export const STATUS_REJECTED = "REJECTED";
export const STATUS_SIGNED = "SIGNED";
